import Reflux from 'reflux';
import { DiscountActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

import { history } from 'helpers';

const localizeDate = (dateStr) => {
  const firstChars = dateStr.substr(0, dateStr.indexOf(' '));
  const properFormat = firstChars.length === 10 && firstChars !== '0000-00-00'; // We want YYYY-MM-DD format, but not '0000-00-00'
  const utcCharsHasNotBeenAddedYet = dateStr.substr(dateStr.length - 3) !== 'UTC';
  const updatedDateStr = (properFormat && utcCharsHasNotBeenAddedYet) ? dateStr + ' UTC' : dateStr;

  return updatedDateStr;
}

var DiscountStore = Reflux.createStore({
  listenables: [DiscountActions],
  data: {
    list: [],
    loading: true
  },

  getInitialState() {
    return this.data;
  },

  onRead(includeRead, callback) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call('discount', 'read', {}, response => {
      DiscountActions.readComplete(response.data);
      if (callback) {
        callback();
      }
    });
  },

  onReadComplete(data) {
    this.data = {
      ...this.data,
      list: data
    };
    this.trigger(this.data);
  },

  onFindById(id) {
    this.data.loading = true;
    this.trigger(this.data);

    return SteelCompass.request('discount', 'findById', { id }).then(
      discount => {
        DiscountActions.findByIdComplete(discount);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },

  findByIdComplete(discount) {
    if (discount.startDate) {
      const newStartDate = localizeDate(discount.startDate);
      discount.startDate = newStartDate;
    }

    if (discount.endDate) {
      const newEndDate = localizeDate(discount.endDate);
      discount.endDate = newEndDate;
    }

    this.data.loading = false;
    this.data.discount = discount;
    this.trigger(this.data);
  },

  onFindByIdError(errorMessage) {
    this.data.loading = false;
    this.data.errorMessage = errorMessage;
    this.trigger(this.data);
  },

  update(discountId, discount) {
    discount.id = discountId;

    return SteelCompass.request('discount', 'update', discount).then(
      discount => {
        if (discount.startDate) {
          const newStartDate = localizeDate(discount.startDate);
          discount.startDate = newStartDate;
        }

        if (discount.endDate) {
          const newEndDate = localizeDate(discount.endDate);
          discount.endDate = newEndDate;
        }

        DiscountActions.updateComplete(discount);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  updateComplete(discount) {
    this.data = {
      ...this.data,
      discount: {
        ...discount
      }
    };
    this.trigger(this.data);
  },

  onCreate(discount) {
    return SteelCompass.call('discount', 'create', discount, response => {
      DiscountActions.createComplete(response.data);
      this.data.saving = true;
      this.trigger(this.data);
    });
  },
  createComplete(discount) {
    DiscountActions.read();
    history.push(`/discount/${discount.id}`);
  },
  onRemoveComplete(discount) {
    let found = -1,
      discounts = this.data.list;
    for (let i = 0; i <= discounts.length; i++) {
      if (discounts[i].id === discount.id) {
        found = i;
        break;
      }
    }
    if (found >= 0) {
      discounts.splice(found, 1);
      this.data.list = discounts;
      this.trigger(this.data);
    }
  },

  onRemove(discount) {
    return SteelCompass.call(
      'discount',
      'delete',
      { id: discount.id },
      response => {
        if (response.isError) {
          DiscountActions.removeError(response.errMsg);
        } else {
          DiscountActions.removeComplete(discount);
        }
      }
    );
  }
});

export default DiscountStore;



// WEBPACK FOOTER //
// ./src/js/stores/Discount.js